import type { FC, SVGProps } from 'react';

export const FlagIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="16"
    fill="currentColor"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M14.5717 4.3058H10.0003V2.28795C10.0003 1.97188 9.74492 1.71652 9.42885 1.71652H2.14314V1.00223C2.14314 0.923661 2.07885 0.859375 2.00028 0.859375H1.00028C0.921708 0.859375 0.857422 0.923661 0.857422 1.00223V15.0022C0.857422 15.0808 0.921708 15.1451 1.00028 15.1451H2.00028C2.07885 15.1451 2.14314 15.0808 2.14314 15.0022V10.2879H6.57171V12.3058C6.57171 12.6219 6.82707 12.8772 7.14314 12.8772H14.5717C14.8878 12.8772 15.1431 12.6219 15.1431 12.3058V4.87723C15.1431 4.56116 14.8878 4.3058 14.5717 4.3058ZM2.14314 9.00223V3.00223H8.71457V9.00223H2.14314ZM13.8574 11.5915H7.85742V10.2879H9.85742C9.936 10.2879 10.0003 10.2237 10.0003 10.1451V5.59152H13.8574V11.5915Z"
    />
  </svg>
);
